import backIcon from "@/assets/img/back.svg";
import renderIcon from "@/assets/img/render.svg";

export class IconsUI {
  constructor() {
    this.backIcon = backIcon;
    this.renderIcon = renderIcon;
  }
}
